module.exports = __webpack_public_path__ + "img/logo.f7922901.png";